<template>
  <BaseEdit
    @edit-confirm-action="updateEntry"
    @edit-cancel-action="resetForm"
    @edit-open-action="loadServerEntry(entry.id)"
    @clear-form-errors="clearFormErrors"
    ref="baseEdit"
    width="50%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :modelNameSingular="modelNameSingular"
  >
    <template slot="editForm">
      <Form
        ref="form"
        :entry="editableEntry"
        :extraData="extraData"
        :isEdit="isEdit"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseEdit>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseEdit from "../../shared/base_edit.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      editableEntry: null,
      formErrors: [],
      extraData: null
    };
  },
  props: {
    entry: Object,
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseEdit: BaseEdit
  },
  methods: {
    loadServerEntry: function(id) {
      this.editableEntry = null;
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_CHART_OF_ACCOUNT_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            id: id
          }
        })
        .then(response => {
          this.editableEntry = response.data.globalContext.chartOfAccount;
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    updateServerEntry: function(chartOfAccount) {

      // console.log("Edit chartOfAccount ", chartOfAccount, chartOfAccount.validations, this.deepFilterEntryWithAllowedFieldsForMutation(chartOfAccount, chartOfAccount.validations))
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: UPDATE_CHART_OF_ACCOUNT_MUTATION,
          variables: {
            input: this.deepFilterEntryWithAllowedFieldsForMutation(chartOfAccount, chartOfAccount.validations)
          }
        })
        .then(response => {
          var errors = response.data.updateChartOfAccount.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseEdit.closeDialog();
            this.$emit("entry-updated");
            this.resetForm();
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.pageLoading = false));
    },
    updateEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.updateServerEntry(this.editableEntry)
      }
    },
    resetForm: function() {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const LOAD_CHART_OF_ACCOUNT_QUERY = gql `
  query ($id: ID!) {
    globalContext {
      chartOfAccount(id: $id) {
        id
        code
        name
        parentId
        parent {
          id
          code
          name
          text
        }
        validations
      }
    }
  }
`;

const UPDATE_CHART_OF_ACCOUNT_MUTATION = gql `
  mutation($input: ChartUpdateInputObject!) {
    updateChartOfAccount(input: $input) {
      chart {
        id
      }
      errors
    }
  }
`;

</script>

<style scoped></style>